import { useContext } from "react";
import { ArrowDownToLine } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ProviderImportContext } from "../../lib/provider-import-context";

export function ProviderImportCatalogButton({
  compact = false,
  disabled = false,
}: {
  compact?: boolean;
  disabled?: boolean;
}) {
  const imports = useContext(ProviderImportContext);
  if (!imports) {
    return null;
  }
  return (
    <Button
      type="button"
      variant="outline"
      className={cn(
        "gap-2 rounded-xl",
        compact && "h-10 px-3 text-xs sm:text-sm",
      )}
      disabled={disabled || imports.disabled || imports.isOpen}
      onClick={imports.openCatalog}
    >
      <ArrowDownToLine className="size-4" aria-hidden="true" />
      Import from provider
    </Button>
  );
}
